const migrations = {
  1: (state) => {
    return {
      ...state,
      alcohol: {
        ...state.alcohol,
        events: [],
        photos: [],
      },
      drinkSelection: {
        ...state.drinkSelection,
        customEvent: {
          text: undefined,
        },
      },
    };
  },
  2: (state) => {
    return {
      ...state,
      drinkSelection: {
        ...state.drinkSelection,
        drinkId: null,
        containerId: null,
      },
    };
  },
};

export default migrations;
